import { Places } from 'src/Constants'
import { MainKeys } from 'src/main/Main.keys'

export class GrupoKeys extends MainKeys {
    get place() {
        return Places.mcGrupo
    }
}

export default GrupoKeys
